import * as React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Button,
  Box,
  Typography,
  CardActions,
  List,
  Checkbox,
  ListItem,
  ListItemIcon,
  ListItemText,
  IconButton,
  Icon,
} from "@mui/material";
import { format as DateFormat } from "date-fns";
import PropTypes from "prop-types";

const Publicacion = (props) => {
  const { datos, onSend } = props;
  const [opciones, setOpciones] = React.useState([]);
  const [checked, setChecked] = React.useState([]);

  React.useEffect(() => {
    if (!datos) return;
    const c =
      !datos.Respuestas || datos.Respuestas === ""
        ? []
        : datos.Respuestas.split(", ").map(Number);
    let o = datos.Opciones.sort((a, b) =>
      a.Orden < b.Orden ? -1 : a.Orden === b.Orden ? 0 : 1,
    );
    c.map((x, index) => {
      const pos = o.findIndex((op) => op.Id === x);

      return (o = arrayMove(o, pos < 0 ? index : pos, index));
    });
    setOpciones(o);
    setChecked(c);
  }, [datos]);
  const arrayMove = (array, fromIndex, toIndex) => {
    const newArray = [...array];

    const startIndex = fromIndex < 0 ? array.length + fromIndex : fromIndex;

    if (startIndex >= 0 && startIndex < array.length) {
      const endIndex = toIndex < 0 ? array.length + toIndex : toIndex;

      const [item] = newArray.splice(fromIndex, 1);
      newArray.splice(endIndex, 0, item);
    }
    return newArray;
  };
  const handleToggle = (value) => {
    const currentIndex = checked.indexOf(value);
    const newChecked = opciones.find((o) => o.Id === value).Exclusivo
      ? []
      : [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
    // if (currentIndex === -1) {
    //   //Posiciono despues del ultimo seleccionado
    //   const pos = opciones.findIndex((x) => x.Id === value);

    //   const newPos =
    //     currentIndex === -1
    //       ? newChecked.length > 0
    //         ? newChecked.length - 1
    //         : 0
    //       : newChecked.length;

    //   setOpciones(arrayMove(opciones, pos, newPos));
    // }
    const o = SortArray(opciones, newChecked);
    setOpciones(o);
  };

  const SortArray = (list, checked) =>
    [...list].sort((a, b) => {
      const cha = checked.findIndex((nc) => nc === a.Id);
      const chb = checked.findIndex((nc) => nc === b.Id);
      if (cha < 0 && chb < 0) {
        return a.Orden < b.Orden ? -1 : a.Orden > b.Orden ? 1 : 0;
      } else if (cha < 0 && chb >= 0) {
        return 1;
      } else if (chb < 0 && cha >= 0) {
        return -1;
      } else {
        return cha < chb ? -1 : cha > chb ? 1 : 0;
      }
    });

  const EnviarRespuesta = () => {
    const arr = [];
    opciones && opciones.map((o) => checked.includes(o.Id) && arr.push(o.Id));

    onSend(arr.join(", "));
  };
  return (
    <Card
      sx={{
        height: "100%",
        minHeight: "100px",
        display: "flex",
        flexDirection: "column",
      }}
      variant="outlined"
    >
      <CardHeader
        title={datos && datos.Nombre}
        subheader={
          datos && (
            <Box>
              <Typography variant="caption">{datos.Descripcion}</Typography>
              <Box display="flex">
                <Typography variant="caption">
                  {DateFormat(new Date(datos.Desde), "dd/MM/yyyy")}
                </Typography>
                <Box sx={{ flexGrow: 1 }} />
                <Typography variant="caption">
                  {DateFormat(new Date(datos.Hasta), "dd/MM/yyyy")}
                </Typography>
              </Box>
            </Box>
          )
        }
      />
      <CardContent
        sx={{
          height: "100%",
          width: "100%",
        }}
      >
        <List>
          {datos &&
            opciones &&
            opciones.map((o, index) => {
              const orden = checked.indexOf(o.Id);
              return (
                <ListItem
                  key={"O" + o.Id}
                  role={undefined}
                  dense
                  sx={{
                    border: "1px solid",
                    marginBottom: "8px",
                    borderRadius: "8px",
                    backgroundColor: "#F0F0F0",
                  }}
                >
                  <ListItemIcon style={{ minWidth: "32px" }}>
                    <Checkbox
                      disabled={
                        !checked.includes(o.Id) &&
                        checked.length === 1 &&
                        opciones.find((o) => o.Id === checked[0]).Exclusivo
                      }
                      edge="start"
                      tabIndex={-1}
                      disableRipple
                      checked={checked.includes(o.Id)}
                      onClick={() => handleToggle(o.Id)}
                    />
                  </ListItemIcon>
                  <ListItemText
                    id={o.Id}
                    primary={
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {orden > -1 && (
                          <Typography
                            color={o.Exclusivo ? "error" : "secondary"}
                            sx={{ pr: 1 }}
                          >
                            {o.Exclusivo ? "!" : orden + 1}
                          </Typography>
                        )}
                        <Typography
                          color={o.Exclusivo ? "primary" : "inherit"}
                          fontWeight={o.Exclusivo ? "bold" : "inherit"}
                        >
                          {o.Opcion}
                        </Typography>
                        <Box sx={{ flexGrow: 1 }} />
                        <Box
                          sx={{
                            display:
                              (o.Exclusivo || !checked.includes(o.Id)) &&
                              "none",
                            paddingLeft: "16px",
                          }}
                        >
                          <IconButton
                            color="primary"
                            disabled={index === 0}
                            size="small"
                            onClick={() => {
                              const posCheck = checked.indexOf(o.Id);
                              const chk = arrayMove(
                                checked,
                                posCheck,
                                posCheck - 1,
                              );
                              setChecked(chk);
                              setOpciones(SortArray(opciones, chk));
                            }}
                          >
                            <Icon>publish</Icon>
                          </IconButton>
                        </Box>
                        <Box
                          style={{
                            display:
                              (o.Exclusivo || !checked.includes(o.Id)) &&
                              "none",
                            paddingLeft: "24px",
                          }}
                        >
                          <IconButton
                            color="primary"
                            size="small"
                            disabled={index === checked.length - 1}
                            onClick={() => {
                              const posCheck = checked.indexOf(o.Id);
                              const chk = arrayMove(
                                checked,
                                posCheck,
                                posCheck + 1,
                              );
                              setChecked(chk);

                              setOpciones(SortArray(opciones, chk));

                              // setOpciones(
                              //   arrayMove(opciones, index, index + 1)
                              // );
                            }}
                          >
                            <Icon>get_app</Icon>
                          </IconButton>
                        </Box>
                      </Box>
                    }
                  />
                </ListItem>
              );
            })}
        </List>
      </CardContent>
      <CardActions>
        <Button
          color="primary"
          disabled={!checked || checked.length === 0}
          endIcon={<Icon>send</Icon>}
          onClick={() => EnviarRespuesta()}
        >
          Enviar respuesta
        </Button>
      </CardActions>
    </Card>
  );
};
Publicacion.propTypes = {
  datos: PropTypes.object,
  onSend: PropTypes.func,
};
export default Publicacion;
